"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PriceContainerProps_1 = require("./PriceContainerProps");
var styles = require("./PriceContainer.css");
var Label_1 = require("../../../components/atoms/Label");
var LabelProps_1 = require("../../../components/atoms/Label/LabelProps");
var utils_1 = require("../../../utils/utils");
var EnEsLanguageKey_1 = require("../../../utils/EnEsLanguageKey");
var defaultCurrency = '$';
var freeText = 'FREE';
var PriceContainer = /** @class */ (function (_super) {
    __extends(PriceContainer, _super);
    function PriceContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.stylesMap = new Map([
            [PriceContainerProps_1.PricingType.LARGE, styles.large],
            [PriceContainerProps_1.PricingType.MEDIUM, styles.medium],
            [PriceContainerProps_1.PricingType.SMALL, styles.small],
            [PriceContainerProps_1.PricingType.XSMALL, styles.xsmall],
            [PriceContainerProps_1.PricingType.CART, styles.cart],
            [PriceContainerProps_1.PricingType.TILE, styles.tile],
            [PriceContainerProps_1.PricingType.FEATURED, styles.featured],
            [PriceContainerProps_1.PricingType.DUETODAY, styles.duetoday],
            [PriceContainerProps_1.PricingType.PERMONTH, styles.permonth],
        ]);
        _this.delimitersMap = new Map([
            [PriceContainerProps_1.PricingType.LARGE, PriceContainerProps_1.DelimiterType.SLASH],
            [PriceContainerProps_1.PricingType.MEDIUM, PriceContainerProps_1.DelimiterType.SLASH],
            [PriceContainerProps_1.PricingType.SMALL, PriceContainerProps_1.DelimiterType.SLASH],
            [PriceContainerProps_1.PricingType.XSMALL, PriceContainerProps_1.DelimiterType.SLASH],
            [PriceContainerProps_1.PricingType.CART, PriceContainerProps_1.DelimiterType.SPACE],
            [PriceContainerProps_1.PricingType.TILE, PriceContainerProps_1.DelimiterType.SLASH],
            [PriceContainerProps_1.PricingType.FEATURED, PriceContainerProps_1.DelimiterType.SLASH],
            [PriceContainerProps_1.PricingType.DUETODAY, PriceContainerProps_1.DelimiterType.SPACE],
            [PriceContainerProps_1.PricingType.PERMONTH, PriceContainerProps_1.DelimiterType.SPACE],
        ]);
        _this.state = { isServer: true };
        return _this;
    }
    PriceContainer.prototype.componentDidMount = function () {
        this.setState({ isServer: false });
    };
    PriceContainer.prototype.render = function () {
        var _a, _b;
        var pricingStyles = this.stylesMap.get(this.props.options.type);
        var isDisplayFree = this.isDisplayFree();
        var delimiter = (this.props.data.billingNote ?
            this.delimitersMap.get(this.props.options.type) :
            PriceContainerProps_1.DelimiterType.SPACE);
        var isDataPriceNegative = this.props.options.isDataPriceNegative ? true : false;
        var minusClass = this.props.options.customClasses && this.props.options.customClasses.minusClass ?
            this.props.options.customClasses.minusClass : '';
        var strikethroughCls = '';
        if (this.props.options && this.props.options.strikeThrough) {
            strikethroughCls = pricingStyles ? styles.strikethrough : styles.noTypeStrikethrough;
        }
        var paymentPeriodStyle = this.props.data.billingNote && this.props.data.billingNote.trim() ?
            [styles.paymentPeriod, this.props.options.paymentMonth].join(' ') : '';
        return (React.createElement("div", { "data-test-id": this.props.testId, className: pricingStyles, tabIndex: ((_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.setTabIndex) ? +this.props.options.setTabIndex : -1 },
            React.createElement("div", { className: styles.hiddenSpoken }, this.getAriaLabelContent(isDisplayFree, delimiter, isDataPriceNegative)),
            React.createElement("span", { className: strikethroughCls, "aria-hidden": "true" },
                React.createElement("span", { className: minusClass }, isDataPriceNegative ? '-' : ''),
                React.createElement("span", { "aria-hidden": "true", className: this.getPriceContainerClassName(isDisplayFree) },
                    isDisplayFree ? (this.props.options && this.props.options.displayFreeText) || freeText :
                        this.checkPriceType(this.props.data.price),
                    !isDisplayFree &&
                        React.createElement("span", { className: paymentPeriodStyle, dangerouslySetInnerHTML: { __html: this.props.data.billingNote } }))),
            this.createTaxesFeesNote(this.props.data),
            this.createSavings(this.props.data)));
    };
    PriceContainer.prototype.createTaxesFeesNote = function (data) {
        if (data.taxesFeesNote) {
            var taxFeeClass = this.props.options && this.props.options.customClasses
                && this.props.options.customClasses.taxesFeesNoteClass
                ? { className: this.props.options.customClasses.taxesFeesNoteClass } : {};
            return (React.createElement("div", __assign({}, taxFeeClass),
                React.createElement(Label_1.default, { testId: utils_1.default('Label', 'TaxesFeesNote'), data: { text: data.taxesFeesNote }, options: { size: LabelProps_1.LabelSizes.MEDIUMBODYALTERNATE } })));
        }
    };
    PriceContainer.prototype.createSavings = function (data) {
        if (data.discountDetails) {
            var text = data.discountDetails;
            var options = {
                className: this.props.options && this.props.options.customClasses ?
                    this.props.options.customClasses.discountDetailsLabel : "",
                size: LabelProps_1.LabelSizes.MEDIUMBODYALTERNATE,
                tag: this.props.options.discountDetailsTag,
                type: LabelProps_1.LabelTypes.SUCCESS,
            };
            var className = this.props.options && this.props.options.customClasses ?
                this.props.options.customClasses.discountDetails
                : "";
            return React.createElement("div", { className: className }, this.createLabel({ text: text }, options, 'Saving'));
        }
    };
    PriceContainer.prototype.createLabel = function (data, options, testIdSuffix) {
        return React.createElement(Label_1.default, { testId: utils_1.default('Label', testIdSuffix), data: data, options: options });
    };
    PriceContainer.prototype.isDisplayFree = function () {
        return Math.abs(this.props.data.price) === 0 && this.props.options.displayFree;
    };
    PriceContainer.prototype.getPriceContainerClassName = function (isDisplayFree) {
        var customClassName = this.props.options.className || '';
        return isDisplayFree ? [styles.base, styles.baseFree, this.props.options.isFreeClass].join(' ')
            : [styles.base, customClassName].join(' ');
    };
    PriceContainer.prototype.getAriaLabelContent = function (isDisplayFree, delimiter, isNegative) {
        // if on the server don't call this function
        if (this.state.isServer) {
            return null;
        }
        if (this.props.options.overrideAccessibility) {
            return "" + this.props.options.accessibility;
        }
        else {
            var negative = isNegative ? EnEsLanguageKey_1.getKeyText('negative') : '';
            var frendlyDel = (delimiter === PriceContainerProps_1.DelimiterType.SLASH) ?
                EnEsLanguageKey_1.getKeyText('per') : delimiter;
            var newBillingNote = (delimiter === PriceContainerProps_1.DelimiterType.SLASH) ?
                this.props.data.billingNote.replace(PriceContainerProps_1.DelimiterType.SLASH, '') : this.props.data.billingNote;
            if (newBillingNote) {
                newBillingNote = newBillingNote.replace(/<[^>]*>/g, '');
            }
            var frendlyNote = (this.props.data.billingNote ?
                (newBillingNote.toLowerCase().startsWith('mo') ?
                    EnEsLanguageKey_1.getKeyText('month') + newBillingNote.replace('mo', ' ') :
                    newBillingNote) :
                '');
            var priceText = isDisplayFree
                ? (this.props.options && this.props.options.displayFreeText) || freeText
                : "" + negative + defaultCurrency + this.checkPriceType(this.props.data.price) + frendlyDel + frendlyNote;
            return (this.props.options.accessibility || '') + " " + priceText;
        }
    };
    PriceContainer.prototype.checkPriceType = function (priceVal) {
        var decimalPoints = this.props.options.decimalPoints || 0;
        var price = priceVal || 0;
        if (typeof price === 'string') {
            price = parseFloat(price);
        }
        if (this.props.options.showAbsolute) {
            price = Number.isInteger(price) ? price : price.toFixed(2);
        }
        else if (decimalPoints > 0) {
            price = price.toFixed(decimalPoints);
        }
        return price;
    };
    PriceContainer.defaultProps = {
        options: {
            className: '',
            customClasses: {
                minusClass: '',
            },
            displayFree: false,
            isDataPriceNegative: false,
            setTabIndex: '-1',
            showAbsolute: false,
            type: PriceContainerProps_1.PricingType.LARGE,
        },
    };
    return PriceContainer;
}(React.Component));
exports.default = PriceContainer;
//# sourceMappingURL=PriceContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/PriceContainer/PriceContainer.js
// module id = 116
// module chunks = 8